import { buildLocalizedPath } from './localizedLinks'
import { getPreferredTranslation } from './getPreferredTranslation'
import { DEFAULT_LOCALE, normalizeLocale } from 'src/i18n/config'
import LINKS from './links'

const getTranslationLocales = (item) =>
  Object.keys(item?.translations || {})
    .map((key) => normalizeLocale(String(key).split('/').pop()))
    .filter(Boolean)

const getTranslationForLocale = (item, locale) =>
  getPreferredTranslation(item, locale, {
    fallbackLocale: null,
    includeDefaultLang: false,
    includeFirstTranslation: false,
    defaultValue: null,
  })

const buildLinkForLocale = (item, locale) => {
  const translation = getTranslationForLocale(item, locale)

  if (!translation) {
    return null
  }

  if (translation.link) {
    return translation.link
  }

  const slug = typeof translation.slug === 'string' ? translation.slug.trim() : ''

  return slug ? buildLocalizedPath(LINKS.PAGES.DETAIL, locale, { slug }) : null
}

export const getPageLink = (item, locale) => {
  const defaultLang = typeof item?.defaultLang === 'string' ? item.defaultLang : item?.defaultLang?.value
  const candidateLocales = [
    ...new Set(
      [
        normalizeLocale(locale) || locale,
        normalizeLocale(defaultLang),
        DEFAULT_LOCALE,
        ...getTranslationLocales(item),
      ].filter(Boolean),
    ),
  ]

  for (const candidateLocale of candidateLocales) {
    const link = buildLinkForLocale(item, candidateLocale)

    if (link) {
      return link
    }
  }

  console.warn(`No detail link could be resolved for locale: ${locale}`)

  return '#'
}
